<template>
  <section class="section banner">
    <div class="section__container banner__container">
      <div class="banner__title">
        <h1>Ferma — сервис аренды облачных касс</h1>
        <p>с полным техническим обслуживанием от&nbsp;OFD.ru </p>
      </div>
      <div class="banner__action">
        <a class="button" v-scrollTo="'calc'">
          Подключить Ferma
          <img src="../../assets/images/chevron.svg" alt="">
        </a>
      </div>
      <div class="banner__img">
        <img src="./assets/background.png"
             srcset="./assets/background@2x.png 2x"
             alt="Элекснет">
      </div>
      <div class="banner__service">
        <h3 class="banner__service-title">Сервис FERMA включает:</h3>
        <ul class="banner__service-list">
          <li>аренду облачных <br>касс, размещенных в&nbsp;ЦОД&nbsp;Tier&nbsp;III</li>
          <li>передачу фискальных данных (ОФД)</li>
          <li>замену ФН в случае заполнения, или истечения срока действия</li>
          <li>отправку кодов маркировки из чеков в систему «Честный знак»</li>
          <li>подключение к ЭДО.Поток для обмена электронными документами</li>
          <li>пользование единым личным кабинетом для управления кассами и передачей фискальных данных</li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Banner',
  data() {
    return {
      opened: false,
    };
  },
  methods: {
    toggleOpen: function () {
      this.opened = !this.opened;
    },
  },
}
</script>

<style src="./component.scss" scoped lang="scss"/>
